import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ViagensCard from './components/ViagensCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const ViagensMain = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Início' },
              { name: 'Viagens' }
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <ViagensCard />
        </Col>
      </Row>
    </Container>
  );
};

export default ViagensMain;
